export interface ChangePasswordModel {
    oldPassword: string,
    newPassword: string
}

export class ChangePasswordModel {
    constructor() {}
}
